export type Country = { name: string; code: string; coords: [number, number] };

export const COUNTRIES: Country[] = [
  // West & Central Africa
  { name: "Côte d'Ivoire", code: 'CI', coords: [-5.55, 7.54] },
  { name: 'Ghana', code: 'GH', coords: [-1.02, 7.95] },
  { name: 'Senegal', code: 'SN', coords: [-14.45, 14.72] },
  { name: 'Nigeria', code: 'NG', coords: [8.68, 9.08] },
  { name: 'Mali', code: 'ML', coords: [-2.0, 18.0] },
  { name: 'Burkina Faso', code: 'BF', coords: [-1.56, 12.37] },
  { name: 'Guinea', code: 'GN', coords: [-11.31, 9.95] },
  { name: 'Guinea-Bissau', code: 'GW', coords: [-15.18, 11.80] },
  { name: 'Sierra Leone', code: 'SL', coords: [-11.78, 8.46] },
  { name: 'Liberia', code: 'LR', coords: [-9.43, 6.43] },
  { name: 'Togo', code: 'TG', coords: [1.22, 8.62] },
  { name: 'Benin', code: 'BJ', coords: [2.32, 9.31] },
  { name: 'Niger', code: 'NE', coords: [8.08, 17.61] },
  { name: 'Chad', code: 'TD', coords: [18.73, 15.45] },
  { name: 'Cameroon', code: 'CM', coords: [12.35, 3.87] },
  { name: 'Congo', code: 'CG', coords: [15.83, -0.23] },
  { name: 'DR Congo', code: 'CD', coords: [23.65, -2.88] },
  { name: 'Gabon', code: 'GA', coords: [11.61, -0.80] },
  { name: 'Equatorial Guinea', code: 'GQ', coords: [10.27, 1.65] },
  { name: 'Central African Republic', code: 'CF', coords: [20.94, 6.61] },
  { name: 'Mauritania', code: 'MR', coords: [-10.94, 21.01] },
  { name: 'Cape Verde', code: 'CV', coords: [-23.61, 16.54] },
  { name: 'Gambia', code: 'GM', coords: [-15.31, 13.44] },
  // East & South Africa
  { name: 'South Africa', code: 'ZA', coords: [25.08, -29.00] },
  { name: 'Kenya', code: 'KE', coords: [37.91, -0.02] },
  { name: 'Ethiopia', code: 'ET', coords: [40.49, 9.14] },
  { name: 'Tanzania', code: 'TZ', coords: [34.89, -6.37] },
  { name: 'Uganda', code: 'UG', coords: [32.29, 1.37] },
  { name: 'Rwanda', code: 'RW', coords: [29.87, -1.94] },
  { name: 'Madagascar', code: 'MG', coords: [46.87, -18.77] },
  { name: 'Mozambique', code: 'MZ', coords: [35.55, -17.27] },
  { name: 'Zimbabwe', code: 'ZW', coords: [29.15, -20.00] },
  { name: 'Zambia', code: 'ZM', coords: [27.85, -13.13] },
  { name: 'Angola', code: 'AO', coords: [17.87, -11.20] },
  { name: 'Namibia', code: 'NA', coords: [18.49, -22.96] },
  { name: 'Malawi', code: 'MW', coords: [34.30, -13.25] },
  { name: 'Somalia', code: 'SO', coords: [46.20, 5.15] },
  { name: 'Sudan', code: 'SD', coords: [30.22, 12.86] },
  { name: 'South Sudan', code: 'SS', coords: [31.30, 7.87] },
  { name: 'Djibouti', code: 'DJ', coords: [42.59, 11.83] },
  // North Africa
  { name: 'Morocco', code: 'MA', coords: [-7.09, 31.79] },
  { name: 'Algeria', code: 'DZ', coords: [3.06, 36.74] },
  { name: 'Tunisia', code: 'TN', coords: [9.54, 33.88] },
  { name: 'Egypt', code: 'EG', coords: [29.86, 26.82] },
  { name: 'Libya', code: 'LY', coords: [17.23, 26.34] },
  // East Asia
  { name: 'China', code: 'CN', coords: [104.19, 35.86] },
  { name: 'Japan', code: 'JP', coords: [138.25, 36.20] },
  { name: 'South Korea', code: 'KR', coords: [127.77, 35.91] },
  { name: 'Taiwan', code: 'TW', coords: [120.97, 23.70] },
  { name: 'Hong Kong', code: 'HK', coords: [114.17, 22.32] },
  // Southeast Asia
  { name: 'Vietnam', code: 'VN', coords: [102.96, 12.57] },
  { name: 'Thailand', code: 'TH', coords: [100.99, 15.87] },
  { name: 'Malaysia', code: 'MY', coords: [109.70, 4.21] },
  { name: 'Singapore', code: 'SG', coords: [103.82, 1.36] },
  { name: 'Indonesia', code: 'ID', coords: [113.92, -0.79] },
  { name: 'Philippines', code: 'PH', coords: [121.77, 12.88] },
  { name: 'Cambodia', code: 'KH', coords: [104.99, 12.57] },
  { name: 'Myanmar', code: 'MM', coords: [95.96, 21.91] },
  // South Asia
  { name: 'India', code: 'IN', coords: [78.96, 20.59] },
  { name: 'Pakistan', code: 'PK', coords: [69.35, 30.38] },
  { name: 'Bangladesh', code: 'BD', coords: [90.36, 23.68] },
  { name: 'Sri Lanka', code: 'LK', coords: [80.77, 7.87] },
  // Middle East
  { name: 'UAE', code: 'AE', coords: [53.85, 23.42] },
  { name: 'Saudi Arabia', code: 'SA', coords: [44.82, 23.89] },
  { name: 'Turkey', code: 'TR', coords: [35.24, 38.96] },
  { name: 'Iran', code: 'IR', coords: [53.68, 32.43] },
  { name: 'Qatar', code: 'QA', coords: [51.18, 25.35] },
  { name: 'Kuwait', code: 'KW', coords: [47.49, 29.34] },
  // Europe
  { name: 'France', code: 'FR', coords: [2.21, 46.23] },
  { name: 'Germany', code: 'DE', coords: [10.45, 51.17] },
  { name: 'United Kingdom', code: 'GB', coords: [-3.44, 55.38] },
  { name: 'Spain', code: 'ES', coords: [-3.75, 40.46] },
  { name: 'Italy', code: 'IT', coords: [12.57, 41.87] },
  { name: 'Portugal', code: 'PT', coords: [-8.22, 39.40] },
  { name: 'Belgium', code: 'BE', coords: [4.47, 50.50] },
  { name: 'Netherlands', code: 'NL', coords: [5.29, 52.13] },
  { name: 'Switzerland', code: 'CH', coords: [8.23, 46.82] },
  { name: 'Sweden', code: 'SE', coords: [18.64, 63.13] },
  { name: 'Norway', code: 'NO', coords: [8.47, 60.47] },
  { name: 'Denmark', code: 'DK', coords: [9.50, 56.26] },
  { name: 'Poland', code: 'PL', coords: [19.15, 51.92] },
  { name: 'Russia', code: 'RU', coords: [105.32, 61.52] },
  { name: 'Greece', code: 'GR', coords: [21.82, 39.07] },
  // Americas
  { name: 'United States', code: 'US', coords: [-95.71, 37.09] },
  { name: 'Canada', code: 'CA', coords: [-96.80, 56.13] },
  { name: 'Brazil', code: 'BR', coords: [-51.93, -14.24] },
  { name: 'Mexico', code: 'MX', coords: [-102.55, 23.63] },
  { name: 'Colombia', code: 'CO', coords: [-74.30, 4.57] },
  { name: 'Argentina', code: 'AR', coords: [-63.62, -38.42] },
  // Oceania
  { name: 'Australia', code: 'AU', coords: [133.78, -25.27] },
];

export function findCountryCoords(name: string): [number, number] | null {
  const norm = name.toLowerCase().trim();
  const match = COUNTRIES.find((c) => c.name.toLowerCase() === norm || c.code.toLowerCase() === norm);
  return match ? match.coords : null;
}
